import React from 'react'

const Investment = ({ style = {} }: { style?: React.CSSProperties }) => {
  return (
    <svg
      width='473'
      height='443'
      viewBox='0 0 473 443'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      style={style}
    >
      <path
        opacity='0.08'
        d='M281.456 337.036C295.337 381.403 318.795 407.914 344.227 407.977C427.181 408.185 423.303 372.584 358.737 372.463C343.35 372.419 328.877 354.412 319.057 323.024C311.69 299.478 307.667 269.877 307.738 239.661C307.841 196.519 313.895 161.193 325.259 137.541C325.523 136.925 348.997 82.5086 366.796 62.8047C367.295 62.2677 367.742 61.747 368.188 61.2262L372.998 85.9145C373.041 86.1108 373.078 86.2898 373.132 86.4633C373.751 88.4413 375.52 89.7736 377.618 89.8412C379.715 89.9088 381.543 88.6891 382.304 86.7367L402.864 33.7848C403.286 32.7576 403.318 31.6426 402.987 30.5842C402.259 28.2592 399.991 26.8544 397.592 27.224L342.065 35.8154C340.629 36.036 339.424 36.8129 338.677 38.0181C337.93 39.2233 337.724 40.7548 338.153 42.1256C338.587 43.5136 339.591 44.5903 340.989 45.1624L362.325 53.6884C347.537 62.6204 320.473 87.6613 302.932 116.352L300.416 120.549C280.926 150.192 269.191 198.23 269.061 249.019C269.007 280.506 273.291 310.94 281.456 337.036Z'
        fill='url(#pattern0)'
      />
      <path
        opacity='0.28'
        d='M140.524 361.715C125.105 388.536 106.045 402.378 89.5226 398.755C32.6008 386.275 42.9765 364.303 85.2282 373.594C95.2255 375.783 107.223 366.17 118.131 347.195C126.314 332.961 133.2 314.311 137.517 294.672C143.678 266.632 144.847 242.812 140.884 225.81C140.801 225.372 133.415 186.641 124.702 171.276C124.456 170.856 124.241 170.453 124.026 170.05L117.338 185.395C117.283 185.517 117.233 185.628 117.172 185.732C116.485 186.928 115.144 187.539 113.772 187.281C112.4 187.022 111.389 185.967 111.177 184.589L105.472 147.229C105.346 146.5 105.487 145.772 105.854 145.132C106.662 143.726 108.338 143.14 109.842 143.726L144.657 157.307C145.558 157.657 146.228 158.335 146.539 159.226C146.85 160.116 146.763 161.141 146.287 161.97C145.804 162.809 144.997 163.364 144.007 163.534L128.922 165.999C137.234 173.931 151.192 194.097 158.44 215.262L159.467 218.351C167.843 240.415 168.527 273.312 161.279 306.323C156.769 326.785 149.593 345.939 140.524 361.715Z'
        stroke='black'
      />
      <path
        opacity='0.5'
        d='M190.562 381.155C174.034 424.605 149.022 449.656 123.632 448.187C36.1619 443.13 46.3095 408.066 111.287 411.863C126.649 412.746 142.18 395.643 153.873 364.904C162.644 341.845 168.442 312.539 170.191 282.374C172.685 239.304 168.77 203.678 158.851 179.384C158.624 178.753 138.47 123.022 121.889 102.282C121.424 101.716 121.009 101.169 120.595 100.623L114.307 124.977C114.253 125.17 114.205 125.346 114.141 125.516C113.404 127.453 111.557 128.677 109.46 128.618C107.362 128.559 105.61 127.232 104.969 125.237L87.6343 71.1429C87.2754 70.0922 87.3105 68.9773 87.7047 67.9408C88.5709 65.6638 90.9196 64.3981 93.292 64.9115L148.201 76.831C149.621 77.1377 150.777 77.9858 151.45 79.2338C152.123 80.4818 152.237 82.0229 151.726 83.3653C151.209 84.7247 150.143 85.739 148.712 86.2259L126.902 93.4516C141.125 103.258 166.632 129.883 182.413 159.578L184.672 163.919C202.341 194.682 211.162 243.339 208.234 294.044C206.392 325.477 200.283 355.598 190.562 381.155Z'
        fill='#E6A4A4'
      />
      <g clipPath='url(#clip0_61_5455)'>
        <path
          d='M236.374 236.723H232.082H169.134C169.134 236.723 178.204 305.054 180.822 324.827C181.294 328.418 184.155 330.192 187.618 330.192C195.772 330.192 221.767 330.192 232.082 330.192C234.743 330.192 236.374 330.192 236.374 330.192C246.689 330.192 272.698 330.192 280.838 330.192C284.3 330.192 287.161 328.418 287.633 324.827C290.252 305.054 299.322 236.723 299.322 236.723H236.374Z'
          fill='#414042'
        />
        <path
          d='M305.016 239.241C305.016 241.001 303.585 242.432 301.811 242.432H166.645C164.885 242.446 163.454 241.001 163.454 239.241V234.191C163.454 232.431 164.885 231 166.645 231H301.811C303.571 231 305.016 232.431 305.016 234.191V239.241Z'
          fill='#414042'
        />
        <path
          d='M176.316 242.445H244.5'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M253.083 242.445H258.334'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M289.808 242.445H280.266'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M181.552 264.852H208.262'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M223.527 264.852H230.68'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M287.905 264.852H262.154'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M285.044 283.451H280.266'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M208.262 283.451H198.247'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M255.716 301.578H272.168'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M217.318 301.578H191.566'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M186.33 317.789H194.914'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M208.262 317.789H258.334'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M282.655 317.789H275.03'
          stroke='white'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M258.792 280.589C258.792 294.152 247.791 305.155 234.228 305.155C220.666 305.155 209.664 294.152 209.664 280.589C209.664 267.026 220.666 256.023 234.228 256.023C247.791 256.038 258.792 267.026 258.792 280.589Z'
          fill='#EBD0D0'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M241.542 278.174C241.542 274.841 239.504 272.823 235.981 272.823H223.889V293.027H227.183V275.584H235.429C237.543 275.641 238.228 276.479 238.228 278.479V286.477H241.542V278.174ZM242.76 293.027C246.283 292.932 248.378 291.085 248.378 287.676V272.823H245.027V287.372C245.027 289.466 244.208 290.228 242.208 290.266H234.363V279.374H231.106V293.027H242.76Z'
          fill='#D52027'
        />
        <path
          d='M254.629 280.589C254.629 291.849 245.502 300.977 234.243 300.977C222.983 300.977 213.856 291.849 213.856 280.589C213.856 269.329 222.983 260.201 234.243 260.201C245.502 260.201 254.629 269.329 254.629 280.589Z'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M234.228 249.269C234.228 249.269 227.719 232.572 234.228 211.111'
          stroke='#414042'
          stroke-width='3'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M234.228 193C234.228 193 254.615 206.835 231.338 220.656C231.338 220.656 208.262 206.835 234.228 193Z'
          fill='#EAC9C9'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M234.228 193C234.228 193 237.733 198.251 234.228 203.015C230.723 207.779 232.182 213.817 232.182 213.817'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M281.223 73.636C281.223 73.636 225.894 35.7723 283.773 10.4405C341.664 -14.8974 334.725 47.1892 334.725 47.1892L330.799 48.483C330.799 48.483 338.605 -7.30625 286.458 14.7326C234.311 36.7715 282.999 70.5668 282.999 70.5668L281.223 73.636Z'
          fill='#949191'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M279.302 66.8911C279.302 66.8911 290.367 39.184 327.971 38.219L367.811 96.9267C367.811 96.9267 354.162 135.963 298.934 135.45L279.302 66.8911Z'
          fill='#949191'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M301.18 115.329C301.18 115.329 265.063 96.072 246.724 123.935L257.835 129.93C257.835 129.93 264.858 106.83 303.462 128.264'
          fill='#949191'
        />
        <path
          d='M301.18 115.329C301.18 115.329 265.063 96.072 246.724 123.935L257.835 129.93C257.835 129.93 264.858 106.83 303.462 128.264'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M282.433 66.7088C282.433 66.7088 318.019 64.9118 325.45 40.3852L282.433 66.7088Z'
          fill='#949191'
        />
        <path
          d='M282.433 66.7088C282.433 66.7088 318.019 64.9118 325.45 40.3852'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M228.518 128.869C228.518 128.869 240.87 117.102 254.166 122.412C267.462 127.723 266.517 140.98 266.517 140.98C266.517 140.98 248.343 145.145 228.518 128.869Z'
          fill='#949191'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M235.289 127.898C235.289 127.898 257.603 130.423 266.529 140.974'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M307.736 46.2315L303.706 36.2458C303.706 36.2458 289.802 37.9491 286.249 46.6189L293.632 53.8525'
          fill='#949191'
        />
        <path
          d='M307.736 46.2315L303.706 36.2458C303.706 36.2458 289.802 37.9491 286.249 46.6189L293.632 53.8525'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M307.296 48.5203C307.296 48.5203 304.008 51.2842 298.814 52.5723'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M305.648 116.772C305.648 116.772 309.413 120.547 306.291 126.527'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
          <use xlinkHref='#image0_61_5455' transform='translate(0 -0.395986) scale(0.01 0.0175684)' />
        </pattern>
        <clipPath id='clip0_61_5455'>
          <rect width='355' height='342' fill='white' transform='translate(59)' />
        </clipPath>
        <image
          id='image0_61_5455'
          width='100'
          height='102'
          xlinkHref='data:image/png;base64,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'
        />
      </defs>
    </svg>
  )
}

export default Investment
